/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface UpdateAuthenticatedUserResponse
 */
export interface UpdateAuthenticatedUserResponse {
    /**
     * 
     * @type {User}
     * @memberof UpdateAuthenticatedUserResponse
     */
    data: User;
}

/**
 * Check if a given object implements the UpdateAuthenticatedUserResponse interface.
 */
export function instanceOfUpdateAuthenticatedUserResponse(value: object): value is UpdateAuthenticatedUserResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateAuthenticatedUserResponseFromJSON(json: any): UpdateAuthenticatedUserResponse {
    return UpdateAuthenticatedUserResponseFromJSONTyped(json, false);
}

export function UpdateAuthenticatedUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAuthenticatedUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': UserFromJSON(json['data']),
    };
}

  export function UpdateAuthenticatedUserResponseToJSON(json: any): UpdateAuthenticatedUserResponse {
      return UpdateAuthenticatedUserResponseToJSONTyped(json, false);
  }

  export function UpdateAuthenticatedUserResponseToJSONTyped(value?: UpdateAuthenticatedUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UserToJSON(value['data']),
    };
}

